import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold font-heading mb-6">Smartgonext</h3>
            <p className="text-neutral-400 mb-6 leading-relaxed">
              Empowering businesses with cutting-edge software solutions. We build the future of digital experiences.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center hover:bg-primary-600 transition-colors">
                <FaFacebookF />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center hover:bg-primary-600 transition-colors">
                <FaTwitter />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center hover:bg-primary-600 transition-colors">
                <FaLinkedinIn />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center hover:bg-primary-600 transition-colors">
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-neutral-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-neutral-400 hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/products" className="text-neutral-400 hover:text-white transition-colors">Products</Link></li>
              <li><Link to="/clients" className="text-neutral-400 hover:text-white transition-colors">Clients</Link></li>
              <li><Link to="/contact" className="text-neutral-400 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services/billing-software" className="text-neutral-400 hover:text-white transition-colors">Billing Software</Link></li>
              <li><Link to="/services/web-development" className="text-neutral-400 hover:text-white transition-colors">Web Development</Link></li>
              <li><Link to="/services#mobile" className="text-neutral-400 hover:text-white transition-colors">Mobile Apps</Link></li>
              <li><Link to="/services#cloud" className="text-neutral-400 hover:text-white transition-colors">Cloud Solutions</Link></li>
              <li><Link to="/services#marketing" className="text-neutral-400 hover:text-white transition-colors">Digital Marketing</Link></li>
              <li><Link to="/blog" className="text-neutral-400 hover:text-white transition-colors">Blog & Resources</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <FaMapMarkerAlt className="mt-1 text-primary-500" />
                <span className="text-neutral-400">
                  17, Mookambigai Street, Sedarapet,<br />
                  Puducherry – 605111
                </span>
              </li>
              <li className="flex items-center gap-3">
                <FaPhone className="text-primary-500" />
                <a href="tel:+919751109239" className="text-neutral-400 hover:text-white transition-colors">+91 97511 09239</a>
              </li>
              <li className="flex items-center gap-3">
                <FaEnvelope className="text-primary-500" />
                <a href="mailto:smartgonext@gmail.com" className="text-neutral-400 hover:text-white transition-colors">smartgonext@gmail.com</a>
              </li>
            </ul>
            <div className="mt-6 space-y-3">
              <a 
                href="https://www.google.com/search?q=smartgonext" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-neutral-400 hover:text-white transition-colors text-sm"
              >
                🔍 Find us on Google
              </a>
              <a 
                href="https://g.page/r/CcoulpWDZuVAEAE/review" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-yellow-400 hover:text-yellow-300 transition-colors font-medium text-sm"
              >
                <span className="underline">Leave us a Review</span>
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-neutral-500 text-sm">
            &copy; {currentYear} Smartgonext Software Solution. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/legal" className="text-neutral-500 text-sm hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/legal" className="text-neutral-500 text-sm hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
